export default __webpack_public_path__ + "static/media/illustration-study-1-n-w.c5405cd6.webp";